import { ref } from "vue";
import { defineStore } from 'pinia'
import CryptoJS from "crypto-js";

export const useEncryptStore = defineStore('crypt', () => {
  const key = ref(null)
  const ready = ref(false)

  const setKey = (val) => {
    key.value = val
  }

  const encrypt = async (data, customKey) => {
    if (!key.value && !customKey) throw new Error("Key not set")
    return CryptoJS.AES.encrypt(data, customKey || key.value).toString()
  }

  const decrypt = async (data, customKey) => {
    if (!key.value && !customKey) throw new Error("Key not set")
    return CryptoJS.AES.decrypt(data, customKey || key.value).toString(CryptoJS.enc.Utf8)
  }

  const setReady = (value) => {
    ready.value = value || true
  }

  return { ready, setKey, encrypt, decrypt, setReady }
})
